var AccessManagerModule = /** @class */ (function () {
    function AccessManagerModule() {
    }
    return AccessManagerModule;
}());
export { AccessManagerModule };
